import clsx from 'clsx';
import * as R from 'ramda';

import { LocationDataTitle } from '@atom/types/taskLocation';

import classes from './workOrderReport.module.css';

interface Props {
  rowMultiAsset: any;
}

const MultiAssetRow = ({ rowMultiAsset }: Props) => {
  const convertNumberToLocaleString = (input: string | number): string => {
    return R.isNil(input) ? '' : Number(input).toLocaleString('en-US');
  };

  const attributes: any[] =
    R.values(R.pathOr({}, ['attributes'], rowMultiAsset)) || [];

  const route =
    attributes.find(item => item.name === LocationDataTitle.ROUTE)?.value || '';

  const direction =
    attributes.find(item => item.name === LocationDataTitle.DIRECTION)?.value ||
    '';

  const startMilepost = attributes.find(
    item => item.name === LocationDataTitle.START_MILEPOST,
  )?.value;

  const endMilepost = attributes.find(
    item => item.name === LocationDataTitle.END_MILEPOST,
  )?.value;

  return (
    <div className={classes.assetRow}>
      <div className={classes.assetName}>{rowMultiAsset?.name}</div>
      <div className={classes.assetRowSub}>
        <div className={clsx(classes.assetValue, classes.route)}>{route}</div>
        <div className={classes.assetValue}>{direction}</div>
        <div className={classes.assetValue}>
          {convertNumberToLocaleString(startMilepost)}
        </div>
        <div className={classes.assetValue}>
          {convertNumberToLocaleString(endMilepost)}
        </div>
      </div>
    </div>
  );
};

export default MultiAssetRow;
